<template>
  <div class="tab-bordered">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'tab-bordered',
  components: {
  },
  props: {
    active: ''
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.tab-bordered {
  @include mq-down(md) {
    margin: 0 -20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabs/TabBordered.vue